/* VYI — scripts communs : en-tête, menu mobile, accordéons, animations */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;

  /* Année du pied de page */
  var y = doc.getElementById('year'); if (y) y.textContent = new Date().getFullYear();

  /* En-tête : bordure après défilement */
  var header = doc.getElementById('site-header');
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* Menu mobile */
  var toggle = doc.getElementById('menu-toggle'), menu = doc.getElementById('mobile-menu');
  function setMenu(open) {
    root.classList.toggle('menu-open', open);
    if (toggle) { toggle.setAttribute('aria-expanded', String(open)); toggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu'); }
  }
  if (toggle && menu) {
    toggle.addEventListener('click', function () { setMenu(!root.classList.contains('menu-open')); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('menu-open')) { setMenu(false); toggle.focus(); } });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 960) setMenu(false); });
  }

  /* Page courante dans la navigation */
  var path = location.pathname.replace(/\/$/, '') || '/';
  doc.querySelectorAll('.nav a').forEach(function (a) {
    var p = a.getAttribute('href').replace(/\/$/, '') || '/';
    if (p === path) a.setAttribute('aria-current', 'page');
  });

  /* Apparition progressive */
  var items = doc.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !document.hidden && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* FAQ : un seul accordéon ouvert à la fois */
  doc.querySelectorAll('.faq details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      d.parentElement.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    });
  });
})();
